/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetJudgmentDto } from './GetJudgmentDto';
import {
    GetJudgmentDtoFromJSON,
    GetJudgmentDtoFromJSONTyped,
    GetJudgmentDtoToJSON,
} from './GetJudgmentDto';

/**
 * 
 * @export
 * @interface GetJudgmentP1DocumentDto
 */
export interface GetJudgmentP1DocumentDto {
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentP1DocumentDto
     */
    id: string;
    /**
     * 
     * @type {GetJudgmentDto}
     * @memberof GetJudgmentP1DocumentDto
     */
    judgment?: GetJudgmentDto | null;
    /**
     * 
     * @type {number}
     * @memberof GetJudgmentP1DocumentDto
     */
    sentVersionNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentP1DocumentDto
     */
    documentType: GetJudgmentP1DocumentDtoDocumentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentP1DocumentDto
     */
    cancellationReason: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentP1DocumentDto
     */
    status: GetJudgmentP1DocumentDtoStatusEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentP1DocumentDto
     */
    error: string | null;
    /**
     * Error mapped to a user-friendly message (original if unmapped)
     * @type {string}
     * @memberof GetJudgmentP1DocumentDto
     */
    errorMessage: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetJudgmentP1DocumentDto
     */
    creationTs: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentP1DocumentDto
     */
    isLatest?: boolean;
}


/**
 * @export
 */
export const GetJudgmentP1DocumentDtoDocumentTypeEnum = {
    Judgment: 'Judgment',
    Cancellation: 'Cancellation'
} as const;
export type GetJudgmentP1DocumentDtoDocumentTypeEnum = typeof GetJudgmentP1DocumentDtoDocumentTypeEnum[keyof typeof GetJudgmentP1DocumentDtoDocumentTypeEnum];

/**
 * @export
 */
export const GetJudgmentP1DocumentDtoStatusEnum = {
    ToSign: 'ToSign',
    WaitingForP1: 'WaitingForP1',
    AcceptedInP1: 'AcceptedInP1',
    RejectedInP1: 'RejectedInP1',
    ValidationFailed: 'ValidationFailed'
} as const;
export type GetJudgmentP1DocumentDtoStatusEnum = typeof GetJudgmentP1DocumentDtoStatusEnum[keyof typeof GetJudgmentP1DocumentDtoStatusEnum];


/**
 * Check if a given object implements the GetJudgmentP1DocumentDto interface.
 */
export function instanceOfGetJudgmentP1DocumentDto(value: object): value is GetJudgmentP1DocumentDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('sentVersionNumber' in value) || value['sentVersionNumber'] === undefined) return false;
    if (!('documentType' in value) || value['documentType'] === undefined) return false;
    if (!('cancellationReason' in value) || value['cancellationReason'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    if (!('errorMessage' in value) || value['errorMessage'] === undefined) return false;
    if (!('creationTs' in value) || value['creationTs'] === undefined) return false;
    return true;
}

export function GetJudgmentP1DocumentDtoFromJSON(json: any): GetJudgmentP1DocumentDto {
    return GetJudgmentP1DocumentDtoFromJSONTyped(json, false);
}

export function GetJudgmentP1DocumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetJudgmentP1DocumentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'judgment': json['judgment'] == null ? undefined : GetJudgmentDtoFromJSON(json['judgment']),
        'sentVersionNumber': json['sentVersionNumber'],
        'documentType': json['documentType'],
        'cancellationReason': json['cancellationReason'],
        'status': json['status'],
        'error': json['error'],
        'errorMessage': json['errorMessage'],
        'creationTs': (json['creationTs'] == null ? null : new Date(json['creationTs'])),
        'isLatest': json['isLatest'] == null ? undefined : json['isLatest'],
    };
}

export function GetJudgmentP1DocumentDtoToJSON(value?: GetJudgmentP1DocumentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'judgment': GetJudgmentDtoToJSON(value['judgment']),
        'sentVersionNumber': value['sentVersionNumber'],
        'documentType': value['documentType'],
        'cancellationReason': value['cancellationReason'],
        'status': value['status'],
        'error': value['error'],
        'errorMessage': value['errorMessage'],
        'creationTs': (value['creationTs'] == null ? null : (value['creationTs'] as any).toISOString()),
        'isLatest': value['isLatest'],
    };
}

